import { render, staticRenderFns } from "./FilerInformation.vue?vue&type=template&id=12227944&"
import script from "./FilerInformation.vue?vue&type=script&lang=js&"
export * from "./FilerInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports